import React, { Component } from 'react'
import PT from 'prop-types'
import { Like } from 'react-facebook'

class LikeBtn extends Component {
  render() {
    return (
      <Like
        href={this.props.to}
        layout="button_count"
        colorScheme="dark"
        share
      />
    )
  }
}

LikeBtn.propTypes = {
  to: PT.string.isRequired,
}

export default LikeBtn



// WEBPACK FOOTER //
// ./src/components/Post/LikeBtn.js